<template>
  <!-- ------------------------------------------------------------>
  <!-- MAIN CONTAINER -->
  <!-- -------------- -->
  <div class="row mt-3 mb-3">
    <!-- ------------------ -->
    <!--   delete confirm   -->
    <!-- ------------------ -->
    <confirm-dialog ref="confirmDialog"></confirm-dialog>
    <!-- ------------------------ -->
    <!--   campaign note dialog   -->
    <!-- ------------------------ -->
    <campaign-note-dialog ref="campaignNoteDialog"></campaign-note-dialog>
    <!-- ------------------ -->
    <!--   main structure   -->
    <!-- ------------------ -->
    <!-- <div class="col"> -->
    <div class="row">
      <p class="bb-sheet-title">CAMPAIGN NOTES</p>
    </div>
    <div class="mt-3 mb-2">
      <!-- ---------- -->
      <!--   search   -->
      <!-- ---------- -->
      <div
        v-if="hasNotes"
        class="row mt-2 mb-3 align-items-center"
      >
        <!-- SEARCH FIELD -->
        <div class="col-2">
          <div class="form-group bb-viewer-search-wrap">
            <div class="form-floating">
              <input
                type="text"
                class="form-control bb-viewer-search-input"
                style="
                  color: white !important;
                  -webkit-text-fill-color: white !important;
                  caret-color: white !important;
                  opacity: 1 !important;
                  font-size: 1.4rem !important;
                "
                placeholder="Search..."
                v-model="searchTerm"
              />
            </div>
          </div>
        </div>

        <!-- MATCH MESSAGE -->
        <div class="col-6 d-flex align-items-center">
          <span class="bb-off-white-message" style="font-size: 1.4rem !important">
            <span v-if="searchTerm.length >= 3">
              <span v-if="filtered_notes.length > 0">
                *** {{ filtered_notes.length }} match{{
                  filtered_notes.length === 1 ? '' : 'es'
                }}
                found ***
              </span>
              <span v-else> *** No matches found *** </span>
            </span>
          </span>
        </div>
      </div>

      <!-- -------- -->
      <!-- headings -->
      <!-- -------- -->
      <div class="row">
        <div class="col-2 text-center">
          <p class="bb-hdg mt-2 mb-3">Timestamp</p>
        </div>
        <div class="col-9 text-center">
          <p class="bb-hdg mt-2 mb-3">Notes</p>
        </div>

        <div class="col-auto ms-3">
          <p class="bb-hdg mt-2 mb-3">&nbsp;</p>
        </div>
        <div class="col-auto ms-3">
          <p class="bb-hdg mt-2 mb-3">&nbsp;</p>
        </div>
      </div>
      <!-- --------- -->
      <!-- data rows -->
      <!-- --------- -->
      <template
        v-for="(a, idx) in filtered_notes"
        :key="a.id || idx"
      >
        <div
          class="row mt-3 mb-3 align-items-center"
          @click="handleEditNote(a)"
        >
          <!-- --------- -->
          <!-- timestamp -->
          <!-- --------- -->
          <div class="col-2">
            <div class="form-group">
              <div class="form-floating">
                <input
                  readonly
                  class="form-control text-center"
                  :value="a.updated_at"
                  autocomplete="off"
                  :id="`note-timestamp-${a.id || 'new'}-${idx}`"
                />
                <label
                  class="readonly bb-float-label optional"
                  :for="`note-timestamp-${a.id || 'new'}-${idx}`"
                  >Timestamp
                </label>
              </div>
            </div>
          </div>
          <!-------- -->
          <!-- note  -->
          <!-- ----- -->
          <div class="col-9">
            <div class="form-group">
              <div class="form-floating">
                <input
                  readonly
                  class="form-control text-left bb-card-description-control"
                  :value="a.note"
                  :id="`note-note-${a.id || 'new'}-${idx}`"
                />
                <label
                  class="readonly bb-float-label optional"
                  :for="`note-note-${a.id || 'new'}-${idx}`"
                  >Note
                </label>
              </div>
            </div>
          </div>
          <!-- ------------- -->
          <!-- delete button -->
          <!-- ------------- -->
          <div class="col-auto d-flex align-items-center gap-2">
            <button
              :disabled="a.starter"
              :id="`note-delete-${a.id || 'new'}-${idx}`"
              type="button"
              @click.stop="confirmDeletion(idx)"
              class="btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
            >
              <ToolTip
                text="Delete Note"
                position="left"
              >
                <img
                  :src="deleteImg"
                  height="48"
                  width="48"
                  alt="delete image"
                />
              </ToolTip>
            </button>
          </div>
          <!-- ----------- -->
          <!-- id (hidden) -->
          <!-- ----------- -->
          <div class="col-4 d-none">
            <div class="form-group">
              <div class="form-floating">
                <input
                  readonly
                  class="form-control text-left"
                  :value="a.id"
                  :id="`note-id-${a.id || 'new'}-${idx}`"
                />
                <label
                  class="readonly bb-float-label optional"
                  :for="`note-id-${a.id || 'new'}-${idx}`"
                  >Id
                </label>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- ---------------- -->
      <!-- no notes message -->
      <!-- ---------------- -->
      <div
        v-if="filtered_notes.length === 0 && !hasValidSearchTerm"
        class="row mt-3 mb-3 align-items-center"
      >
        <div class="col text-center">
          <p class="bb-hdg mt-2 mb-3 text-start bb-off-white-message">
            *** Character has no Campaign Notes ***
          </p>
        </div>
      </div>
      <!-- <div
        v-if="filtered_notes.length === 0 && hasValidSearchTerm"
        class="row mt-3 mb-3 align-items-center"
      >
        <div class="col text-center">
          <p class="bb-hdg mt-2 mb-3 text-start bb-off-white-message">
            *** No notes match your search ***
          </p>
        </div>
      </div> -->
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import { inject } from 'vue'

import CampaignNoteDialog from '../components/CampaignNoteDialog.vue'
import ConfirmDialog from '../components/ConfirmDialog.vue'
import ToolTip from '../components/ToolTip.vue'

import capitaliseFirstLetter from '../helpers/capitaliseFirstLetter.js'
import getTimestamp from '../helpers/getTimestamp.js'

import deleteImg from '../assets/images/bbDelete48.png'

export default {
  name: 'CharacterSheetCampaignNotes',
  //========================================
  // props
  //-------
  props: {
    character: {
      type: Object,
      required: true,
    },
  },
  //========================================================
  // components
  //------------
  components: {
    ToolTip,
    ConfirmDialog,
    CampaignNoteDialog,
  },
  //========================================================
  // setup
  //-------
  setup() {
    const global = inject('global')
    return { global }
  },
  //========================================================
  // data
  //------
  data() {
    return {
      deleteImg,
      searchTerm: '',
      //
      delete: false,
      //
      local_character: null,
      //
      local_notes: [],
      errors: [],
      originalNotes: [],
    }
  },
  //========================================================
  // watch
  //-------
  watch: {
    character: {
      handler(newCharacter) {
        if (!newCharacter) {
          return
        }
        //------------------------------------------------
        // copy received notes & cap first letter of note
        //------------------------------------------------
        this.local_notes = (newCharacter.campaign_notes || [])
          .map((a) => ({
            ...a,
            note: capitaliseFirstLetter(a.note) || '',
          }))
          .sort((a, b) =>
            (b.updated_at || '').localeCompare(a.updated_at || '', undefined, {
              sensitivity: 'base',
              numeric: true,
            }),
          )
      },
      immediate: true,
      deep: true,
    },
  },
  //========================================================
  // computed
  //----------
  computed: {
    hasNotes() {
      return this.local_notes.length > 0
    },
    hasValidSearchTerm() {
      return this.searchTerm.length >= 3
    },
    filtered_notes() {
      if (!this.hasValidSearchTerm) {
        return this.local_notes
      }

      const term = this.searchTerm.toLowerCase()

      return this.local_notes.filter((n) =>
        (n.note || '').toLowerCase().includes(term),
      )
    },
  },
  //========================================================
  // methods
  //---------
  methods: {
    //=============================================
    // set view
    //----------
    setView(view) {
      this.setCurrentView(view)
    },
    //=============================================
    // confirm deletion
    //------------------
    async confirmDeletion(idx) {

      this.delete = true

      const ok = await this.$refs.confirmDialog.show({
        title: 'Delete Note',
        message: 'Confirm Deletion',
        subject: this.local_notes[idx]
          ? this.local_notes[idx].updated_at
          : 'Note ' + (idx + 1),
        okButton: 'OK',
        cancelButton: 'Cancel',
      })
      if (ok) {
        //-------------------
        // emit delete event
        //-------------------
        this.searchTerm = ''
        this.$emit('delete-campaign-note', this.local_notes[idx])
        //-----------------------
        // remove row from array
        //-----------------------
        this.local_notes.splice(idx, 1)
      } else {
        this.delete = false
      }
    },
    //========================================================
    // handle edit note
    //------------------
    async handleEditNote(note) {

      this.searchTerm = ''

      const resp = await this.$refs.campaignNoteDialog.show({
        title: 'Campaign Note',
        subject: '',
        message: '',
        note: note ? note.note : '',
        okButton: note == null ? 'Add' : 'OK',
        cancelButton: 'Cancel',
      })

      // proceeding with add/update
      if (resp && resp.ok) {
        // set payload
        const payload = {
          type: 'campaign_notes',
          key: 'note',
          value: resp.note,
          name: note?.updated_at || getTimestamp(),
          id: note?.id || null,
        }

        // adding note
        if (!note?.id) {
          this.$emit('add-campaign-note', payload)
        } else {
          // updating note
          this.$emit('update-campaign-note', payload)
        }
      }
    },
  },
}
</script>
